import { LangCode, getTranslation } from '../../../components/feature/LanguageSelector';

interface Property {
  id: number;
  title: string;
  location: string;
  price: string;
  type: string;
  bedrooms: number;
  bathrooms: number;
  area: string;
  description: string;
}

interface PropertyInfoProps {
  property: Property;
  lang: LangCode;
}

export default function PropertyInfo({ property, lang }: PropertyInfoProps) {
  const t = (key: string) => getTranslation(lang, key);

  const features = [
    { icon: 'ri-hotel-bed-line', label: t('prop_info_bedrooms'), value: `${property.bedrooms}` },
    { icon: 'ri-drop-line', label: t('prop_info_bathrooms'), value: `${property.bathrooms}` },
    { icon: 'ri-ruler-line', label: t('prop_info_area'), value: property.area },
    { icon: 'ri-map-pin-line', label: t('prop_info_location'), value: property.location },
  ];

  return (
    <div>
      {/* Price */}
      <div className="mb-8">
        <p className="text-4xl sm:text-5xl font-bold text-gray-900">{property.price}</p>
      </div>

      {/* Features Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-10">
        {features.map((f) => (
          <div key={f.label} className="bg-gray-50 rounded-2xl p-4 text-center">
            <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
              <i className={`${f.icon} text-red-600 text-2xl`}></i>
            </div>
            <p className="text-xs text-gray-500 font-medium mb-1">{f.label}</p>
            <p className="text-sm font-bold text-gray-900">{f.value}</p>
          </div>
        ))}
      </div>

      {/* Description */}
      <div className="mb-10">
        <h2 className="text-xl font-bold text-gray-900 mb-4">{t('prop_info_description')}</h2>
        <p className="text-gray-600 leading-relaxed text-base">{property.description}</p>
      </div>

      {/* Details */}
      <div className="border-t border-gray-100 pt-8">
        <h2 className="text-xl font-bold text-gray-900 mb-5">{t('prop_info_details')}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[
            { label: t('prop_info_operation'), value: property.type },
            { label: t('prop_info_bedrooms'), value: `${property.bedrooms}` },
            { label: t('prop_info_bathrooms'), value: `${property.bathrooms}` },
            { label: t('prop_info_area'), value: property.area },
            { label: t('prop_info_location'), value: property.location },
            { label: t('prop_info_reference'), value: `RLR-${String(property.id).padStart(4, '0')}` },
          ].map((item) => (
            <div key={item.label} className="flex items-center justify-between py-3 border-b border-gray-50">
              <span className="text-gray-500 text-sm">{item.label}</span>
              <span className="text-gray-900 font-semibold text-sm">{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
